export default {
  namespaced: true,
  state: {
    cdn: process.env.VUE_APP_CDN,
    apiFront: process.env.VUE_APP_API_URL_FRONT,
  },
  getters: {
    cdn (state) {
      return state.cdn
    },
    apiFront (state) {
      return state.apiFront
    },
  },
  actions: {
  },
  mutations: {
  },
}
